import type { SiteKey } from '@tamtamy/paperbits-common/src/multisite/siteContract';

export class MenuRuntimeModel {
    constructor(
        public locale: string,
        public siteKey: SiteKey,
        public siteLanguage: string
    ) {}

    public serialize(encode: boolean = false): string {
        const serial = JSON.stringify(this);
        return encode ? encodeURIComponent(serial) : serial;
    }
}

export class MenuRuntimeModelBuilder {
    private _locale?: string;
    private _siteKey?: SiteKey;
    private _siteLanguage: string;


    public locale(locale: string): MenuRuntimeModelBuilder {
        this._locale = locale;
        return this;
    }

    public siteKey(siteKey: SiteKey): MenuRuntimeModelBuilder {
        this._siteKey = siteKey;
        return this;
    }

    public siteLanguage(siteLanguage: string): MenuRuntimeModelBuilder {
        this._siteLanguage = siteLanguage;
        return this;
    }

    public build(): MenuRuntimeModel {
        return new MenuRuntimeModel(this._locale, this._siteKey, this._siteLanguage);
    }

    public static fromSerialized(serial: string, decode: boolean = false): MenuRuntimeModel {
        try {
            let decodedSerial = serial;
            if (decode) {
                decodedSerial = decodeURIComponent(serial);
            }
            const m: MenuRuntimeModel = <MenuRuntimeModel> JSON.parse(decodedSerial);
            return new MenuRuntimeModel(m.locale, m.siteKey, m.siteLanguage);
        } catch (error) {
            console.error("[Menu] fromSerialized() - JSON parse exception.", serial);
            return null;
        }
    }
}